import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import JBImage from 'components/essentials/JBImage';
import IconArrowLeftWhite from 'components/icons/Slider/iconArrowLeftWhite';
import IconArrowRightWhite from 'components/icons/Slider/iconArrowRightWhite';
import Link from 'components/consumer/Link';
import useScreen from 'hooks/useScreen';
import NukaCarousel from 'components/external/NukaCarousel';

const PDPCollectionSliderUI = ({
  loading,
  productImgs = [],
  collectionSlug,
  collectionLink = '',
}) => {
  const { isMobileOrTablet } = useScreen();
  const [showControls, setShowControls] = useState(false);

  useEffect(() => {
    // Show controls by default on mobile & tablet, but within a useEffect hook
    // so that it is only set on mount and does not affect initial render
    if (isMobileOrTablet) {
      setShowControls(true);
    }
  }, [isMobileOrTablet]);

  if (!productImgs?.length) {
    return <div className="PDPCollectionSliderUI__filler" />;
  }

  if (loading) {
    return <div className="PDPCollectionSliderUI--loader">Loading...</div>;
  }

  const finalSliderHeight = 300;

  return (
    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
    <div
      className="w-full mt-6"
      onMouseOver={() => {
        setShowControls(true);
      }}
      onMouseOut={() => {
        setShowControls(false);
      }}
    >
      <Link to={`/${collectionLink}`} className="no-underline">
        <div className="text-lg font-bold text-brand mb-2">{`More from the ${collectionSlug ||
          ''}`}</div>
      </Link>

      <NukaCarousel
        slidesToShow={isMobileOrTablet ? 2 : 3}
        cellSpacing={0}
        className="m-0 px-[.7rem] py-0 [&_.slider-slide]:!flex [&_.slider-slide]:items-center"
        dragging
        width="100%"
        initialSlideHeight={finalSliderHeight}
        renderCenterLeftControls={({ previousSlide }) => {
          if (productImgs.length < 3) return null;
          return (
            <button
              type="button"
              className={cx(
                '!bg-transparent !border-0 w-[30px] h-[30px] cursor-pointer transition-[all_.2s_ease-in] [&_svg]:max-[1023px]:w-2.5 btn !bg-white left-2 transform-[translateX(-50%)]',
                {
                  'opacity-0': !showControls,
                  'opacity-100': showControls,
                }
              )}
              aria-label="Previous slide"
              onClick={previousSlide}
            >
              {' '}
              <IconArrowLeftWhite />
            </button>
          );
        }}
        renderCenterRightControls={({ nextSlide }) => {
          if (productImgs.length < 3) return null;
          return (
            <button
              type="button"
              className={cx(
                '!bg-transparent !border-0 w-[30px] h-[30px] cursor-pointer transition-[all_.2s_ease-in] [&_svg]:max-[1023px]:w-2.5 btn !bg-white right-2 transform-[translateX(50%)]',
                {
                  'opacity-0': !showControls,
                  'opacity-100': showControls,
                }
              )}
              aria-label="Next slide"
              onClick={nextSlide}
            >
              <IconArrowRightWhite />
            </button>
          );
        }}
        renderBottomCenterControls={() => null}
      >
        {productImgs.map(prodImg => (
          <div
            className="min-h-[110px] p-5 flex flex-col items-center justify-center"
            key={prodImg.url}
          >
            <Link to={prodImg.url}>
              <JBImage
                src={prodImg.src}
                width="200"
                height="200"
                fit="clip"
                trim="color"
              />
            </Link>
          </div>
        ))}
      </NukaCarousel>
    </div>
  );
};

PDPCollectionSliderUI.propTypes = {
  loading: PropTypes.bool,
  productImgs: PropTypes.array,
  collectionSlug: PropTypes.string,
  collectionLink: PropTypes.string,
};

export default PDPCollectionSliderUI;
